import React from "react";
import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";
import ToolTip from "../../../parts/tooltip-portal";
import submit from "submit-form";
import BackArrowButton from "../../../parts/back-arrow-button";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";

class StorefrontScripts extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      global: "",
      paymentSuccess: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { activeUser, organizationOwner } = this.context.locals;
    const userToRequest = getUserToRequest(activeUser, organizationOwner);
    const { customBranding } = userToRequest;
    let initialState = {};

    if (customBranding && customBranding.storefrontSnippets) {
      const { global, paymentSuccess } = customBranding.storefrontSnippets;
      initialState = {
        global,
        paymentSuccess,
      };
    }

    this.setState(initialState);
  }

  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    });
  }

  renderPaymentTooltip() {
    return (
      <ToolTip
        body={[
          <div className="paymentSucess-tooltip">
            <p>
              Snippet executed when a payment is successful, this is on plain
              Javascript
            </p>
            <p> Example using Google Tag Manager:</p>
            <p>{`gtag("event", "conversion", {`}</p>
            <p>send_to: "AW-YYYYYY/XXXXX",</p>
            <p>
              unit_amount: <span style={{ color: "green" }}>%PRICE%</span>,{" "}
            </p>
            <p>
              interval: <span style={{ color: "green" }}>%INTERVAL%</span>,{" "}
            </p>
            <p>
              email: <span style={{ color: "green" }}>%EMAIL%</span>,
            </p>
            <p>{`});`}</p>
            <p>
              <span style={{ color: "green" }}>Green: Placeholder</span>
            </p>
          </div>,
        ]}
      >
        <img className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  }

  renderGlobalTooltip() {
    return (
      <ToolTip
        body={["Main snippet executed in the <head> section of the storefront"]}
      >
        <img className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  }

  render() {
    const { global, paymentSuccess } = this.state;
    const placeholders = {
      global: `
      <script src="https://yourcdn.script.com/script.js"></script>
      <script>scriptFunction(new Date());</script>`,
      paymentSuccess: ` 
      gtag("event", "conversion", {
        send_to: "AW-YYYYY/XXXXX",
        unit_amount: %PRICE%,
        interval: %INTERVAL%,
        email: %EMAIL%,
      });`,
    };
    return (
      <div className="Main Settings-Branding Settings-Integrations">
        <SettingsNav />

        <BackArrowButton
          classNames="only-show-mobile settings-back"
          text="Storefront Scripts"
          onBack={() =>
            submit(`/coaching-portal/settings/profile`, {
              method: "GET",
            })
          }
        />
        <div className="Content">
          <div className="frame alt">
            <form
              id="form-storefront"
              method="POST"
              encType="multipart/form-data"
              data-noreset
            >
              <div className="wrapper">
                <div className="inputs-right">
                  <div
                    className="label inline"
                    style={{
                      fontSize: 20,
                      marginBottom: 20,
                    }}
                  >
                    Storefront Integrations
                  </div>
                  <div className="inline info">
                    In this section you'll be able to setup integrations with
                    external services such Facebook Pixel, Google Tag Manager,
                    Rewardfull, etc...
                    <br />
                    <br />
                    Please contact info@mystrengthbook.com before adding
                    anything to this section of the app.
                  </div>
                  <div
                    className="label inline"
                    style={{
                      fontSize: 16,
                      marginBottom: 20,
                    }}
                  >
                    Snippets
                  </div>
                  <div className="inputs-row grow">
                    <div className="column">
                      <div className="label inline">Global Site Snippet</div>
                      {this.renderGlobalTooltip()}
                      <textarea
                        name="global"
                        className="textarea-input"
                        placeholder={placeholders.global}
                        value={global}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="inputs-row grow">
                    <div className="column">
                      <div className="label inline">
                        Payment Success Snippet
                      </div>
                      {this.renderPaymentTooltip()}
                      <textarea
                        name="paymentSuccess"
                        className="textarea-input"
                        placeholder={placeholders.paymentSuccess}
                        value={paymentSuccess}
                        onChange={this.handleChange}
                      />
                      <div className="inline info">
                        <p>
                          Placeholders:{" "}
                          <p>
                            <span className="placeholder-tag">%PRICE%</span> -
                            This is the price of the plan that the customer
                            paid, it comes in the form of a number, e.g. $39,99
                            = 3999{" "}
                          </p>{" "}
                          <p>
                            <span className="placeholder-tag">%INTERVAL%</span>{" "}
                            - This is the interval of the plan that the customer
                            paid, it comes in the form of a string (month or
                            year){" "}
                          </p>{" "}
                          <p>
                            <span className="placeholder-tag">%EMAIL%</span> -
                            This is the email of the customer, it comes in the
                            form of a string{" "}
                          </p>{" "}
                        </p>
                        <p>
                          Used for matching events and values from our platform
                          and send it to your external services.
                        </p>
                        <p className="warning-scripts-storefront">
                          Warning: Adding a script can cause the site
                          performance of the strorefront to be compromised.
                          MyStrengthBook reserves the right to remove the
                          scripts at anytime, if necessary.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="column button-column" data-col="1/1">
                    <button className="button-input save" type="submit">
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const StorefrontScriptsController = (app) => {
  app
    .get(
      "/storefront-scripts",
      set("heading", "Edit Storefront Scripts"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      ({ res }) => (res.body = <StorefrontScripts />)
    )
    .post(
      "/storefront-scripts",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body } = req;
        const { activeUser, organizationOwner } = locals;
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        const { customBranding = {} } = userToRequest;
        const newBody = {};

        if (
          customBranding &&
          customBranding.storefrontSnippets &&
          customBranding.storefrontSnippets.active
        ) {
          body.active = true;
        } else {
          assert(
            false,
            400,
            "Ask for permissions in order to update the scripts"
          );
        }
        newBody.customBranding = Object.assign({}, customBranding);
        newBody.customBranding.storefrontSnippets = body;
        try {
          await api(`user/${userToRequest._id}`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", "Successfully updated");
        } catch (e) {
          flash("error", e.message);
        }

        res.redirect("/coaching-portal/settings/storefront-scripts");
      }
    );
};

export default StorefrontScriptsController;
